<template lang="pug">
  #app
    router-view
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}

</script>

<style lang="stylus">
body
  margin 0
  padding 0
  &.has-modal
    overflow hidden
    
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
  padding 0
      

.grid
  display flex
  flex-wrap wrap
  margin 0 -10px
  .item
    //flex 1
    padding 10px
    .yearbook-page
      background #f3f3f3
      border-radius 6px
      //padding 120px 0
      text-align center
      width 440px
      img
        max-width 100%

article
  margin-top 70vh
  position relative
  z-index 1
  padding-bottom 100px
  .page
    background #fff
    .page-wrapper
      max-width 1024px
      margin 0 auto
  h2
    text-align center


</style>
